export default __webpack_public_path__ + "static/media/neraca putih 1200x600 (1).49004fe9.png";